export const SunIcon = ({ className = "", variant = "black", ...rest }) => (
  <img
    src={`/assets/logos/sun-${variant}.png`}
    alt=""
    aria-hidden="true"
    className={`select-none object-contain ${className}`}
    draggable={false}
    {...rest}
  />
);

export const Roundel = ({ className = "", variant = "black", ...rest }) => (
  <img
    src={`/assets/logos/roundel-${variant}.webp`}
    alt="Pantheon Art"
    className={`select-none object-contain ${className}`}
    draggable={false}
    {...rest}
  />
);

export const InlineLogo = ({ className = "" }) => (
  <img
    src="/assets/logos/inline-logo.png"
    alt="Pantheon Art"
    data-testid="inline-logo"
    className={`h-6 w-auto select-none ${className}`}
    draggable={false}
  />
);

export const CircledArrow = ({ className = "" }) => (
  <svg
    viewBox="0 0 32 32"
    className={`link-arrow-icon ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="16" cy="16" r="14.5" />
    <line x1="10" y1="16" x2="22" y2="16" />
    <polyline points="17 11 22 16 17 21" />
  </svg>
);

export const SunburstGraphic = ({ className = "" }) => (
  <svg viewBox="0 0 96 48" className={className} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true">
    <path d="M16 44 a32 32 0 0 1 64 0" />
    {Array.from({ length: 7 }).map((_, i) => (
      <line key={i} x1="48" y1="4" x2="48" y2="14" transform={`rotate(${i * 30 - 90} 48 44)`} />
    ))}
  </svg>
);

export const ArchGraphic = ({ className = "" }) => (
  <svg viewBox="0 0 64 88" className={className} fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
    <path d="M8 84 V40 a24 24 0 0 1 48 0 V84 Z" />
  </svg>
);

export const CirclesGraphic = ({ className = "" }) => (
  <svg viewBox="0 0 88 56" className={className} fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
    <circle cx="30" cy="28" r="24" />
    <circle cx="58" cy="28" r="24" />
  </svg>
);

export const StarGraphic = ({ className = "" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
    <path d="M24 4 C26 18 30 22 44 24 C30 26 26 30 24 44 C22 30 18 26 4 24 C18 22 22 18 24 4 Z" />
  </svg>
);
